import { render, staticRenderFns } from "./customer-freight-charge.vue?vue&type=template&id=7052a124"
import script from "./customer-freight-charge.vue?vue&type=script&lang=js"
export * from "./customer-freight-charge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports